/**
 * Endpoint constants for mate-service routes (/mateapi/...) and SDK-consumed
 * FormCMS routes. FormCMS API calls should go through FormCmsApiClient instead
 * of using these constants directly.
 */
export const ENDPOINTS = {
    // ─── Mate-service routes (/mateapi) ────────────────────────────────────────
    CHAT: {
        HISTORY: '/mateapi/chat/history',
        STATUS: '/mateapi/chat/status',
        PAGE_ADDONS: '/mateapi/page-addons',
        CANCEL: '/mateapi/chat/cancel',
    },
    AI: {
        PROVIDERS: '/mateapi/ai/providers',
        LOGS: '/mateapi/ai/logs',
        DELETE_LOG: '/mateapi/ai/logs/:id',
        GENERATE_DATA: '/mateapi/ai/generate-data',
    },
    MATE_TASKS: {
        LATEST: '/mateapi/tasks',
        TOGGLE_ITEM: '/mateapi/tasks/:taskId/items/:index/toggle',
    },

    // ─── FormCMS routes consumed by SDK (prefer FormCmsApiClient for new code) ─
    AUTH: {
        LOGIN: '/api/login',
        REGISTER: '/api/register',
        LOGOUT: '/api/logout',
        ME: '/api/me',
        PROFILE_PASSWORD: '/api/profile/password',
        PROFILE_AVATAR: '/api/profile/avatar',
    },
    SYSTEM: {
        IS_READY: '/api/system/is-ready',
        DOWNLOAD_PLUGINS: '/api/system/download-plugins',
    },
    SCHEMA: {
        ALL: '/api/schemas?type=',
        SAVE: '/api/schemas',
        DEFINE: '/api/schemas/entity/define',
        DELETE: '/api/schemas/:id',
        PUBLISH: '/api/schemas/publish',
        HISTORY: '/api/schemas/history/:schemaId',
        GET_BY_NAME: '/api/schemas/name/:name',
        GET_BY_ID: '/api/schemas/:id',
        GET_BY_SCHEMA_ID: '/api/schemas/schema/:id',
        GET_ENTITY: '/api/schemas/entity/:entityName',
    },
    QUERY: {
        GET_DATA: '/api/queries/:id',
        PAGE_DATA: '/api/page-data',
    },
    ASSETS: {
        BASE: '/api/assets',
        BY_ID: '/api/assets/:id',
        BY_PATH: '/api/assets/path',
        ENTITY: '/api/assets/entity',
        INFO: '/api/assets/base',
        DELETE: '/api/assets/delete/:id/',
        META: '/api/assets/meta/',
        VIDEO: '/api/assets/video',
        CONVERT_MP3: '/api/assets/convert-mp3/:id',
        CONVERT_M4B: '/api/assets/convert-m4b/:id',
        CONVERT_M4A: '/api/assets/convert-m4a/:id',
        PROGRESS: '/api/assets/progress',
    },
    TASKS: {
        ENTITY: '/api/tasks/entity',
        ALL: '/api/tasks',
        EXPORT: '/api/tasks/export',
        EMIT: '/api/tasks/emit',
        IMPORT_DEMO: '/api/tasks/import/demo',
        ARCHIVE: '/api/tasks/export/archive/:id',
        DOWNLOAD: '/api/tasks/export/download/:id',
        IMPORT: '/api/tasks/import',
    },
    ENTITIES: {
        LIST: '/api/entities/:schemaName',
        TREE: '/api/entities/tree/:schemaName',
        ITEM: '/api/entities/:schemaName/:id',
        UPDATE: '/api/entities/:schemaName/update',
        INSERT: '/api/entities/:schemaName/insert',
        DELETE: '/api/entities/:schemaName/delete',
        PUBLICATION: '/api/entities/:schemaName/publication',
        JUNCTION_IDS: '/api/entities/junction/target_ids/:schemaName/:id/:field',
        JUNCTION_DATA: '/api/entities/junction/:schemaName/:id/:field',
        JUNCTION_SAVE: '/api/entities/junction/:schemaName/:id/:field/save',
        JUNCTION_DELETE: '/api/entities/junction/:schemaName/:id/:field/delete',
        COLLECTION: '/api/entities/collection/:schemaName/:id/:field',
        COLLECTION_INSERT: '/api/entities/collection/:schemaName/:id/:field/insert',
        LOOKUP: '/api/entities/lookup/:schemaName',
    },
    CHUNKS: {
        BASE: '/api/chunks/',
        STATUS: '/api/chunks/status',
        COMMIT: '/api/chunks/commit',
    },
    NOTIFICATIONS: {
        BASE: '/api/notifications',
    },
    SUBSCRIPTIONS: {
        PRICES: '/api/subscriptions/sub_prices',
        SESSIONS: '/api/subscriptions/sub_sessions',
        INFO: '/api/subscriptions/sub_info',
    },
    ENGAGEMENTS: {
        LIST: '/api/engagements/list/:type',
        DELETE: '/api/engagements/delete/:id',
        PAGE_COUNTS: '/api/engagements/page-counts',
        VISIT_COUNTS: '/api/engagements/visit-counts',
        COUNTS: '/api/engagements/counts',
    },
    BOOKMARKS: {
        FOLDERS: '/api/bookmarks/folders',
        LIST: '/api/bookmarks/list/:folderId',
        UPDATE_FOLDER: '/api/bookmarks/folders/update/:id',
        DELETE_FOLDER: '/api/bookmarks/folders/delete/:id',
        DELETE: '/api/bookmarks/delete/:id',
    },
    GRAPHQL: '/graphql',
} as const;
